import { render, staticRenderFns } from "./ControlBox.vue?vue&type=template&id=32f764eb&"
import script from "./ControlBox.vue?vue&type=script&lang=js&"
export * from "./ControlBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../ceesar.scenario.editor/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports